import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AlertService } from './alert.service';
import { BehaviorSubject } from 'rxjs/Rx';  
import { GridDataResult } from '@progress/kendo-angular-grid';  
import { State, CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/Rx';
import { map, tap } from 'rxjs/operators';
import { Router, UrlSerializer } from '@angular/router';
import { environment } from '@environments/environment';


type FunctionCallback = (table: string, res: any) => void;

type PaginationCallback = (result: any, table: string, state: any) => void;


@Injectable({
  providedIn: 'root'
})
export class DatasourceService extends BehaviorSubject<GridDataResult>{

  public API_URL: string = `${environment.apiUrl}/api`;

  public ROWS_PEAR_PAGE: number = 10;

  // state: State;

  public loading: boolean = false;        

  constructor(public http: HttpClient, private alertService: AlertService, private router: Router, private serializer: UrlSerializer) {     
    
    super(null); 
    console.log(this.constructor.name);
    // this.state = this.getStateEmpty();

  }  

  public getStateEmpty(): State {      

    let state : State = {
      skip: 0, 
      take: this.ROWS_PEAR_PAGE, 
      sort: [], 
      filter: {
        logic: "and",
        filters: []
      }, 
      group: []
    }
    return state;

  }

  public getAllPromise(table: string, state: State) : Promise<any>{  
    
    let promise = new Promise((resolve, reject) => {
      this.get(table, state)  
        .toPromise()
        .then(
          res => { resolve(res); }, 
          error => { reject(error); }
        );
    });
    return promise;

  }

  public getById(table: string, id: number, detail?: boolean) {  
    
    if(!detail)
      return this.http.get(`${this.API_URL}/${table}/${id}`);
    else
      return this.http.get(`${this.API_URL}/${table}/${id}/detail`);

  }

  public getByColumn(table: string, column: string, value: string) {  
    
    let state : State = {
      skip: 0, 
      take: 0, 
      sort: [], 
      filter: {
        logic: "and",
        filters: [
          {
            field: column,
            operator: 'eq',
            value: value
          }
        ]
      }, 
      group: []
    }
    // return state;

    this.loading = true;
    return this.http.post(`${this.API_URL}/${table}/search`, state)
    .pipe(
      // map(response => (<GridDataResult>{
      //     data: response['value'],
      //     total: parseInt(response['@odata.count'], 10)
      // })),
      tap(() => this.loading = false)
    )

  }

  // public getByColumn(table: string, id: number) {  
    
  //   return this.http.get(`${this.API_URL}/${table}/${id}`);

  // }

  public getAll(table: string, state: State, callback?: FunctionCallback): void {  
    // this.state = state;
    this.get(table, state)  
        // .subscribe(x =>super.next(x));
        .subscribe(
          (res) => {
            // super.next(x)
            console.log("GET Request is successful: ", table, res);              
            if(callback)
              callback(table, res);
          },
          (fail) => {        
            console.log("Error", fail);
            this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
          }
        ); 
  }
  
  public pagination(table: string, state: State, callback?: PaginationCallback): void {  

    // this.state = state;
    this.get(table, state)  
        .subscribe((x) => {
          super.next(x) 
          if(callback)
            callback(x, table, state);
        });

  }  

  get(table: string, state: State): any {

    this.loading = true;
    return this.http.post(`${this.API_URL}/${table}/search`, state)
        .pipe(
          // map(response => (<GridDataResult>{
          //     data: response['value'],
          //     total: parseInt(response['@odata.count'], 10)
          // })),
          tap(() => this.loading = false)
        )
        // .subscribe(x =>super.next(x));

  }

  post(table: string, params: any): any {

    this.loading = true;
    return this.http.post(`${this.API_URL}/${table}`, params)
        .pipe(
          tap(() => this.loading = false)
        )

  }

  public add(table: string, data: any, state: State, callback?: FunctionCallback): any {  

    this.addRow(table, data) 
      .subscribe(
        (res) => {
          console.log("POST Request is successful: ", table, res.data[0]);
          if(res.data.length != 0)
            this.pagination(table, state);
          if(callback)
            callback(table, res);
        },
        (fail) => {        
          console.log("Error", fail);
          this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      ); 

  }

  addRow(table: string, data: any): any {    

    return this.http.post(`${this.API_URL}/${table}`, data);

  }

  public add_batch(table: string, data: any, state: State, callback?: FunctionCallback): void {  

    this.addRowBatch(table, data)  
      .subscribe(
        (res) => {
          console.log("POST Request is successful: ", table, res);
          // if(res.data.length != 0)
            // this.pagination(table, state);
          if(callback)
            callback(table, res);
        },
        (fail) => {        
          console.log("Error", fail);
          this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      );

  }

  addRowBatch(table: string, data: any): any {    

    return this.http.post(`${this.API_URL}/${table}_batch`, data);

  }

  public update(table: string, data: any, state: State, callback?: FunctionCallback): void {  

    this.updateRow(table, data)  
      .subscribe(
        (res) => {
          console.log("PUT Request is successful: ", table, res.data[0]);
          if(res.data.length != 0){
            if(state != null)
              this.pagination(table, state);
          }
          if(callback)
            callback(table, res);
        },
        (fail) => {        
          console.log("Error", fail);
          this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      );

  }

  updateRow(table: string, data: any): any {    

    return this.http.put(`${this.API_URL}/${table}/${data.id}`, data);

  }

  public update_batch(table: string, data: any, state: State, callback?: FunctionCallback): void {  

    this.updateRowBatch(table, data)  
      .subscribe(
        (res) => {
          console.log("PUT Request is successful: ", table, res);
          // if(res.data.length != 0)
            // this.pagination(table, state);
          if(callback)
            callback(table, res);
        },
        (fail) => {        
          console.log("Error", fail);
          this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      );

  }

  updateRowBatch(table: string, data: any): any {    

    return this.http.put(`${this.API_URL}/${table}_batch`, data);

  }

  public add_update(table: string, data: any, state: State, callback?: FunctionCallback): void {  

    this.addUpdateRow(table, data)  
      .subscribe(
        (res) => {
          console.log("PATCH Request is successful: ", table, res.data[0]);
          if(res.data.length != 0)
            this.pagination(table, state);
          if(callback)
            callback(table, res);
        },
        (fail) => {        
          console.log("Error", fail);
          this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      );

  }

  addUpdateRow(table: string, data: any): any {    

    return this.http.patch(`${this.API_URL}/${table}/${data.id}`, data);

  }

  public add_update_batch(table: string, data: any, callback?: FunctionCallback): void {  

    this.addUpdateRowBatch(table, data)  
      .subscribe(
        (res) => {
          console.log("PATCH Request is successful: ", table, res);
          // if(res.data.length != 0)
            // this.pagination(table, state);
          if(callback)
            callback(table, res);
        },
        (fail) => {        
          console.log("Error", fail);
          this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      );

  }

  addUpdateRowBatch(table: string, data: any): any {    

    return this.http.patch(`${this.API_URL}/${table}_batch`, data);

  }

  public remove(table: string, data: any, state: State, callback?: FunctionCallback): void {      

    this.removeRow(table, data)  
      .subscribe(
        (res) => {
          console.log("DELETE Request is successful: ", table, res.data[0]);
          if(res.data.length != 0)
            this.pagination(table, state);
          if(callback)
            callback(table, res);
        },
        (fail) => {        
          console.log("Error", fail);
          this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      );  

  }

  removeRow(table: string, data: any): any {    

    return this.http.delete(`${this.API_URL}/${table}/${data.id}`);

  }

  public remove_batch(table: string, column: string, value: any, state: State, callback?: FunctionCallback): void {  

    this.removeRowBatch(table, column, value)  
      .subscribe(
        (res) => {
          console.log("DELETE Request is successful: ", table, res);
          // if(res.data.length != 0)
            // this.pagination(table, state);
          if(callback)
            callback(table, res);
        },
        (fail) => {        
          console.log("Error", fail);
          this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      );

  }

  removeRowBatch(table: string, column: string, value: any): any {    

    return this.http.delete(`${this.API_URL}/${table}_batch/${column}/${value}`);

  }

  getByColumnAutocomplete(table: string, filter: FilterDescriptor): any {

    this.loading = true;
    return this.http.post(`${this.API_URL}/${table}/search_column`, filter)
        .pipe(
          // map(response => (<GridDataResult>{
          //     data: response['value'],
          //     total: parseInt(response['@odata.count'], 10)
          // })),
          tap(() => this.loading = false)
        )
        // .subscribe(x =>super.next(x));

  }

}